import React, { useState } from 'react'
import PageLoading from '../../../components/UI/status/loading'
import { getRocketChatMessageById, searchMessage } from '../../../api'
import { ThreadsItem } from './threadsSecton/threadsItem'

export const SearchSection = ({ setShowSearchSection, loading = false, fetchAroundMessages, setMessages,
    userAvatars, selectedChannel, personId, setSelectedThread, setSelectedMessageId, messages
}) => {
    const [searchTerm, setSearchTerm] = useState('')
    const [list, setList] = useState([])

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value)
    }

    const handleKeyDown = async (e) => {
        if (e.key === 'Enter') {
            const res = await searchMessage({
                roomId: selectedChannel,
                personId: personId,
                searchText: searchTerm
            })
            if(res.success) setList(res.messages)
        }
    }

    const handleClickMessage = async (msg) => {
        if (msg.tmid) {
            const res = await getRocketChatMessageById({
                personId: personId,
                messageId: msg.tmid
            })
            setSelectedThread(res.message)
            setSelectedMessageId(msg._id)
        } else {
            await fetchAroundMessages(msg.ts)
            setSelectedMessageId(msg._id)
        }
    }

    return (
        <>
            <div className='channel-heding'>
                <div>{'Search Messages'}</div>
                <div className='cursor-pointer' onClick={() => setShowSearchSection(false)}>x</div>
            </div>
            <div style={{ margin: '8px 0' }}>
                <input
                    type="text"
                    placeholder="Search messages..."
                    value={searchTerm}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                    }}
                />
            </div>
            {loading ? (
                <div className='loadingStyle'>
                    <PageLoading />
                </div>
            ) : (
                <div className="threads-section-container messageStyle">
                    {list.map((msg) => {
                        let text = msg.msg
                        if (msg.mentions) msg.mentions.forEach((mention) => {
                            text = text.replaceAll(`@${mention.username}`,
                                `<span class='mention'>@${mention.name}</span>`
                            )
                        })
                        const user = userAvatars.filter((user) => user.username === msg.u.username)[0]
                        const item = {
                            sender_person: msg.u.name || msg.u.username,
                            id: '',
                            created_at: msg.ts,
                            text: text,
                            status: '',
                            img: user ? user.avatar : ''
                        }
                        return (
                            <ThreadsItem
                                key={msg._id || msg.ts}
                                item={item}
                                msg={msg}
                                receipt={[]}
                                isPinnedMessagesSection={true}
                                onClickItem={handleClickMessage}
                            />
                        )
                    })}
                </div>
            )}
        </>
    )
}
